<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Partners" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('TOOLS: Subscripciones')"
          :ctaText="$t('Acceder')"
          ctaTarget="admin.tools"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-08-07-Tools%20-%20Subcripciones.jpeg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Partners: New Franquicia')"
          subtitle=""
          :ctaText="$t('Acceder')"
          ctaTarget="https://newfranquicia.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-08-07-Newfranquicia.jpeg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Dataroom: Soporte y ayuda')"
          :ctaText="$t('Acceder')"
          ctaTarget="#"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-mano-usando-computadora-portatil-pantalla-virtual-documento-aprobar-linea-concepto-gestion-erp-garantia-calidad-papel.jpg"
        ></dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Partners',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Partners'],
      title: 'Partners'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
